import { render, staticRenderFns } from "./YuqingleixingfenxiDetail.vue?vue&type=template&id=1f761847&scoped=true&"
import script from "./YuqingleixingfenxiDetail.vue?vue&type=script&lang=js&"
export * from "./YuqingleixingfenxiDetail.vue?vue&type=script&lang=js&"
import style0 from "./YuqingleixingfenxiDetail.vue?vue&type=style&index=0&id=1f761847&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f761847",
  null
  
)

export default component.exports